// import React from "react";
// import "bootstrap/dist/css/bootstrap.min.css";

// const App = ({ goToTab }) => {
//   return (
//     <div className="container-fluid my-4">
//       <div className="table-responsive">
//         <table className="table">
//           <thead className="thead-light">
//             <tr>
//               <th>Sr.No</th>

//               <th>Qualification</th>
//               <th>Year From</th>
//               <th>Year To</th>
//               <th>University</th>
//               <th>Institution</th>
//               <th>Div%</th>
//               <th> Highest Qualification</th>
//               <th></th>
//             </tr>
//           </thead>
//           <tbody>
//             <tr>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               <td>
//                 <select className="form-select">
//                   <option>Select</option>
//                 </select>
//               </td>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               <td>
//                 <input type="text" className="form-control" />
//               </td>
//               <td>
//                 <select className="form-select">
//                   <option>Select</option>
//                 </select>
//               </td>
//               <td>
//                 <button className="btn btn-primary">Add</button>{" "}
//                 {/* Add button */}
//               </td>
//             </tr>
//           </tbody>
//         </table>
//       </div>
//       <div className="d-flex justify-content-end mb-3">
//         <button className="btn btn-primary border" onClick={() => goToTab(5)}>
//           Next
//         </button>
//       </div>
//     </div>
//   );
// };

// export default App;



import React, { useState ,useEffect} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { ApiUrl } from "../../../ApiUrl";

const App = ({ goToTab, educationData, setCourseDetailsInParent }) => {
  const [formData, setFormData] = useState({
    qualification: "",
    yearFrom: "",
    yearTo: "",
    university: "",
    institution: "",
    div: "",
    highestQualification: "",
  });

  const [dataList, setDataList] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});

  const isFutureYear = (value) => {
    if (!value) return false;
    const year = Number(value);
    if (Number.isNaN(year)) return false;
    return year > new Date().getFullYear();
  };

  const isValidDivPercent = (value) => {
    if (value === "" || value === null || value === undefined) {
      return true;
    }

    const numeric = Number(value);
    return !Number.isNaN(numeric) && numeric >= 0 && numeric <= 100;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };



useEffect(() => {
  if (educationData && educationData.length > 0) {
    const first = educationData[0];

    // Only set the first item into input fields
    setFormData({
      qualification: first.qualification_type || "",
      yearFrom: first.year_from ? first.year_from.split("-")[0] : "",
      yearTo: first.year_to ? first.year_to.split("-")[0] : "",
      university: first.university || "",
      institution: first.institution || "",
      div: first.marks || "",
      highestQualification: first.qualification_type || "",
    });

    // Do NOT set dataList with the rest
    setDataList([]); // Keep table empty initially
  }
}, [educationData]);



const handleAdd = () => {

  // Year From validation
  if (!/^\d{4}$/.test(formData.yearFrom)) {
    alert("Please enter a valid Year From (YYYY)");
    return;
  }

  // Year To validation
  if (!/^\d{4}$/.test(formData.yearTo)) {
    alert("Please enter a valid Year To (YYYY)");
    return;
  }

  if (isFutureYear(formData.yearFrom) || isFutureYear(formData.yearTo)) {
    setValidationErrors({
      yearFrom: isFutureYear(formData.yearFrom)
        ? "Year cannot be in the future."
        : "",
      yearTo: isFutureYear(formData.yearTo)
        ? "Year cannot be in the future."
        : "",
    });
    return;
  }

  // Year comparison
  if (parseInt(formData.yearTo) < parseInt(formData.yearFrom)) {
    alert("Year To cannot be less than Year From");
    return;
  }

  // Div% validation
  if (
    formData.div === "" ||
    isNaN(formData.div) ||
    Number(formData.div) < 0 ||
    Number(formData.div) > 100
  ) {
    alert("Div% must be between 0 and 100");
    return;
  }

  setDataList((prev) => [...prev, formData]);

  setFormData({
    qualification: "",
    yearFrom: "",
    yearTo: "",
    university: "",
    institution: "",
    div: "",
    highestQualification: "",
  });
  setValidationErrors({});
};  // const handleNext = async () => {
  //   const employeeId = localStorage.getItem("employeeId");

  //   if (!employeeId) {
  //     alert("Employee ID not found in local storage.");
  //     return;
  //   }

  //   if (dataList.length === 0) {
  //     alert("Please add at least one qualification before proceeding.");
  //     return;
  //   }

  //   // Helper to format year to full date
  //   const formatYearToDate = (year) => {
  //     if (!year || year.length !== 4) return null;
  //     return `${year}-01-01`;
  //   };

  //   // Construct payload
  //   const payload = {
  //     created_by: 0,
  //     qualifications_details: dataList.map((item) => ({
  //       qualification_id: 0, // hardcoded or replace with actual if available
  //       qualification_type: item.qualification,
  //       year_from: formatYearToDate(item.yearFrom),
  //       year_to: formatYearToDate(item.yearTo),
  //       university: item.university,
  //       institution: item.institution,
  //       marks: item.div,
  //     })),
  //   };

  //   try {
  //     const response = await fetch(
  //       `${ApiUrl.apiurl}STAFF/registrationQualificationCreateUpdate/${employeeId}/`,
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     if (response.ok) {
  //       const result = await response.json();
  //       console.log("Successfully submitted:", result);
  //       goToTab(5); // Proceed to the next tab
  //     } else {
  //       const errorData = await response.json();
  //       console.error("Failed to submit data:", errorData);
  //       alert("Error submitting qualifications. Check console for details.");
  //     }
  //   } catch (error) {
  //     console.error("Error during API call:", error);
  //     alert("Something went wrong while submitting the data.");
  //   }
  // };

  const handleNext = async () => {
    const hasInvalidDiv = [formData, ...dataList].some(
      (item) => !isValidDivPercent(item.div)
    );

    if (hasInvalidDiv) {
      alert("Div% must be between 0 and 100");
      return;
    }

    const formatYearToDate = (year) => {
      if (!year || year.length !== 4) return null;
      return `${year}-01-01`;
    };

    const qualificationDetails = [formData, ...dataList]
      .filter((item) => item.qualification || item.university || item.institution)
      .map((item) => ({
        qualification_id: 0,
        qualification_type: item.qualification,
        year_from: formatYearToDate(item.yearFrom),
        year_to: formatYearToDate(item.yearTo),
        university: item.university,
        institution: item.institution,
        marks: item.div,
      }));

    sessionStorage.setItem(
      "staff_registration_qualification",
      JSON.stringify(qualificationDetails)
    );
    goToTab(5);
  };

  useEffect(() => {
    const formatYearToDate = (year) => {
      if (!year || year.length !== 4) return null;
      return `${year}-01-01`;
    };

    const qualificationDetails = [formData, ...dataList]
      .filter((item) => item.qualification || item.university || item.institution)
      .map((item) => ({
        qualification_id: 0,
        qualification_type: item.qualification,
        year_from: formatYearToDate(item.yearFrom),
        year_to: formatYearToDate(item.yearTo),
        university: item.university,
        institution: item.institution,
        marks: item.div,
      }));

    sessionStorage.setItem(
      "staff_registration_qualification",
      JSON.stringify(qualificationDetails)
    );
  }, [formData, dataList]);

  return (
    <div className="container-fluid my-4">
      <div className="table-responsive">
        <table className="table table-bordered">
          <thead className="thead-light">
            <tr>
              <th>Sr.No</th>
              <th>Qualification</th>
              <th>Year From</th>
              <th>Year To</th>
              <th>University</th>
              <th>Institution</th>
              <th>Div%</th>
              <th>Highest Qualification</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {dataList.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{row.qualification}</td>
                <td>{row.yearFrom}</td>
                <td>{row.yearTo}</td>
                <td>{row.university}</td>
                <td>{row.institution}</td>
                <td>{row.div}</td>
                <td>{row.highestQualification}</td>
                <td></td>
              </tr>
            ))}
            <tr>
              <td>{dataList.length + 1}</td>
              <td>
                <select
                  className="form-select"
                  name="qualification"
                  value={formData.qualification}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="B.Sc">B.Sc</option>
                  <option value="M.Sc">M.Sc</option>
                  <option value="PhD">PhD</option>
                </select>
              </td>
              <td>
<input
  type="text"
  className={`form-control ${validationErrors.yearFrom ? "is-invalid" : ""}`}
  name="yearFrom"
  value={formData.yearFrom}
  maxLength="4"
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    setValidationErrors((prev) => ({
      ...prev,
      yearFrom:
        value.length === 4 && isFutureYear(value)
          ? "Year cannot be in the future."
          : "",
    }));
    setFormData({
      ...formData,
      yearFrom: value,
    });
  }}
/>              {validationErrors.yearFrom && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.yearFrom}
                  </div>
                )}</td>
              <td>
                <input
  type="text"
  className={`form-control ${validationErrors.yearTo ? "is-invalid" : ""}`}
  name="yearTo"
  value={formData.yearTo}
  maxLength="4"
  onChange={(e) => {
    const value = e.target.value.replace(/\D/g, "");
    setValidationErrors((prev) => ({
      ...prev,
      yearTo:
        value.length === 4 && isFutureYear(value)
          ? "Year cannot be in the future."
          : "",
    }));
    setFormData({
      ...formData,
      yearTo: value,
    });
  }}
/>
                {validationErrors.yearTo && (
                  <div className="invalid-feedback d-block">
                    {validationErrors.yearTo}
                  </div>
                )}
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  name="university"
                  value={formData.university}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
                  type="text"
                  className="form-control"
                  name="institution"
                  value={formData.institution}
                  onChange={handleChange}
                />
              </td>
              <td>
                <input
  type="number"
  className="form-control"
  name="div"
  min="0"
  max="100"
  value={formData.div}
  onChange={(e) => {
    const value = e.target.value;

    if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
      setFormData({
        ...formData,
        div: value,
      });
    }
  }}
/>
              </td>
              <td>
                <select
                  className="form-select"
                  name="highestQualification"
                  value={formData.highestQualification}
                  onChange={handleChange}
                >
                  <option value="">Select</option>
                  <option value="B.Sc">B.Sc</option>
                  <option value="M.Sc">M.Sc</option>
                  <option value="PhD">PhD</option>
                </select>
              </td>
              <td>
                <button className="btn btn-primary" onClick={handleAdd}>
                  Add
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between mb-3 mt-2"></div>
    </div>
  );
};

export default App;


